import { Injectable } from '@angular/core';
import { VERSION, BUILD_DATE, BUILD_ENV } from '@/app/version';

@Injectable({
  providedIn: 'root'
})
export class VersionService {
  private readonly version = VERSION;
  private readonly buildDate = BUILD_DATE;
  private readonly buildEnv = BUILD_ENV;

  /**
   * Get the current application version
   * @returns version string (e.g., "1.0.0")
   */
  getVersion(): string {
    return this.version;
  }

  /**
   * Get the version with 'v' prefix
   * @returns version string (e.g., "v1.0.0")
   */
  getFullVersion(): string {
    return `v${this.version}`;
  }

  /**
   * Get the build date
   * @returns ISO date string
   */
  getBuildDate(): string {
    return this.buildDate;
  }

  /**
   * Get formatted build date
   * @returns formatted date string (e.g., "27/10/2025 12:00:00")
   */
  getFormattedBuildDate(): string {
    const date = new Date(this.buildDate);
    return date.toLocaleString('es-PE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  }

  /**
   * Get the build environment
   * @returns environment string (e.g., "production", "development")
   */
  getBuildEnv(): string {
    return this.buildEnv;
  }

  /**
   * Get complete version information
   * @returns object with all version details
   */
  getVersionInfo() {
    return {
      version: this.version,
      fullVersion: this.getFullVersion(),
      buildDate: this.buildDate,
      formattedBuildDate: this.getFormattedBuildDate(),
      buildEnv: this.buildEnv
    };
  }

  /**
   * Log version information to console
   */
  logVersion(): void {
    console.log(`%c🚀 SIGO ${this.getFullVersion()}`, 'color: #4CAF50; font-size: 16px; font-weight: bold;');
    console.log(`%c📅 Build Date: ${this.getFormattedBuildDate()}`, 'color: #2196F3;');
    console.log(`%c🔧 Environment: ${this.buildEnv}`, 'color: #FF9800;');
    console.log(`%c🏢 NetSolutions Perú S.A.C.`, 'color: #9E9E9E;');
  }
}
